"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: scale(0.9);\n  }\n  100% {\n    transform: scale(1.0);\n  }\n"], ["\n  0% {\n    transform: scale(0.9);\n  }\n  100% {\n    transform: scale(1.0);\n  }\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 1.5rem;\n  width: 90vw;\n  max-width: 24.889rem;\n  box-shadow: ", ";\n  ", ";\n  z-index: 9999;\n  transition: transform 0.35s ease-out, opacity 0.15s ease-in;\n  transform: ", ";\n  opacity: ", ";\n"], ["\n  position: relative;\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 1.5rem;\n  width: 90vw;\n  max-width: 24.889rem;\n  box-shadow: ", ";\n  ", ";\n  z-index: 9999;\n  transition: transform 0.35s ease-out, opacity 0.15s ease-in;\n  transform: ", ";\n  opacity: ", ";\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  margin-top: 40px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"], ["\n  margin-top: 40px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  font-family: ", ";\n  display: inline-block;\n  color: #646464;\n\n  &:hover {\n    cursor: pointer;\n  }\n"], ["\n  ", ";\n  font-family: ", ";\n  display: inline-block;\n  color: #646464;\n\n  &:hover {\n    cursor: pointer;\n  }\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  line-height: 1.25;\n"], ["\n  line-height: 1.25;\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  transition: ", ";\n  z-index: 9998;\n  overflow-y: auto;\n  > * {\n    margin: auto 16px;\n  }\n"], ["\n  position: fixed;\n  bottom: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ", ";\n  transition: ", ";\n  z-index: 9998;\n  overflow-y: auto;\n  > * {\n    margin: auto 16px;\n  }\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _polished = require("polished");

var _buoyText = require("buoy-text");

var _buoyButton = require("buoy-button");

var _buoyButton2 = _interopRequireDefault(_buoyButton);

var _buoyTheme = require("buoy-theme");

var _buoyCloseIcon = require("buoy-close-icon");

var _buoyCloseIcon2 = _interopRequireDefault(_buoyCloseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var growModal = (0, _styledComponents.keyframes)(_templateObject);

var DialogBox = _styledComponents2.default.div.withConfig({
  displayName: "src__DialogBox",
  componentId: "sc-1hr4wg-0"
})(_templateObject2, _buoyTheme.colors.white, _buoyTheme.constants.borderRadius, _buoyTheme.constants.boxShadow, (0, _buoyTheme.responsive)("padding", "48px 40px 40px", "48px 40px 40px", "48px 40px 40px", "48px 40px 40px", "48px 24px 24px"), function (props) {
  return props.show ? 'scale(1.0)' : 'scale(0.9)';
}, function (props) {
  return props.show ? '1' : '0';
});

var Buttons = _styledComponents2.default.div.withConfig({
  displayName: "src__Buttons",
  componentId: "sc-1hr4wg-1"
})(_templateObject3);

var CancelButton = _styledComponents2.default.a.withConfig({
  displayName: "src__CancelButton",
  componentId: "sc-1hr4wg-2"
})(_templateObject4, (0, _buoyTheme.fontSize)("bodyMain"), _buoyTheme.fontFamily);
var ModalParagraph = (0, _styledComponents2.default)(_buoyText.Paragraph).withConfig({
  displayName: "src__ModalParagraph",
  componentId: "sc-1hr4wg-3"
})(_templateObject5);

var ModalBackground = _styledComponents2.default.div.withConfig({
  displayName: "src__ModalBackground",
  componentId: "sc-1hr4wg-4"
})(_templateObject6, function (props) {
  return props.show ? (0, _polished.transparentize)(0.5, _buoyTheme.colors.neutralDarkest(props)) : 'transparent';
}, function (props) {
  return props.show ? 'background 0.35s ease-in' : 'background 0.25s ease-in';
});

var Dialog = function Dialog(_ref) {
  var children = _ref.children,
      heading = _ref.heading,
      message = _ref.message,
      showSubmit = _ref.showSubmit,
      submitEnabled = _ref.submitEnabled,
      submitText = _ref.submitText,
      submitClick = _ref.submitClick,
      showCancel = _ref.showCancel,
      cancelText = _ref.cancelText,
      fadeAway = _ref.fadeAway,
      show = _ref.show;
  return _react2.default.createElement(
    DialogBox,
    { onClick: function onClick(e) {
        return e.stopPropagation();
      }, show: show },
    _react2.default.createElement(
      _buoyText.HeadingThree,
      {
        fontSize: "h3",
        weight: "light",
        alignLeft: true,
        margin: "0"
      },
      heading
    ),
    message && _react2.default.createElement(
      ModalParagraph,
      { margin: "12px 0" },
      message
    ),
    _react2.default.createElement(
      "div",
      null,
      children
    ),
    (showSubmit || showCancel) && _react2.default.createElement(
      Buttons,
      null,
      showCancel && _react2.default.createElement(
        CancelButton,
        { onClick: fadeAway },
        cancelText
      ),
      showSubmit && _react2.default.createElement(
        _buoyButton2.default,
        {
          margin: "0 0 0 24px",
          disabled: !submitEnabled,
          display: "block",
          onClick: submitClick
        },
        submitText
      )
    ),
    _react2.default.createElement(_buoyCloseIcon2.default, { top: "14px", right: "14px", onClick: fadeAway, color: "black" })
  );
};

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this));

    _this.toggleDialog = function () {
      // we want a transition effect where the background blurs in first and then
      // the modal pops in
      _this.state.showDialog ? _this.setState({ showDialog: false }) : _this.setState({ showDialog: true });
    };

    _this.toggleBackground = function () {
      // we want a transition effect where the background blurs in first and then
      // the modal pops in
      _this.state.showBackground ? _this.setState({ showBackground: false }) : _this.setState({ showBackground: true });
    };

    _this.componentDidMount = function () {
      setTimeout(_this.toggleBackground, 100);
      setTimeout(_this.toggleDialog, 350);
    };

    _this.fadeAway = function () {
      _this.toggleDialog();
      _this.toggleBackground();
      setTimeout(_this.props.cancelClick, 350);
    };

    _this.state = { showDialog: false, showBackground: false };
    return _this;
  }

  _createClass(Modal, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        ModalBackground,
        { show: this.state.showBackground,
          onClick: this.props.closeOnOutsideClick ? this.fadeAway : null
        },
        _react2.default.createElement(Dialog, _extends({ fadeAway: this.fadeAway, show: this.state.showDialog
        }, this.props))
      );
    }
  }]);

  return Modal;
}(_react2.default.Component);

Modal.propTypes = {
  heading: _propTypes2.default.string.isRequired,
  message: _propTypes2.default.string,
  showSubmit: _propTypes2.default.bool,
  submitEnabled: _propTypes2.default.bool,
  submitText: _propTypes2.default.string,
  submitClick: _propTypes2.default.func,
  showCancel: _propTypes2.default.bool,
  cancelClick: _propTypes2.default.func.isRequired,
  cancelText: _propTypes2.default.string,
  closeOnOutsideClick: _propTypes2.default.bool
};

Modal.defaultProps = {
  showSubmit: true,
  submitEnabled: true,
  showCancel: true,
  cancelText: 'Cancel',
  closeOnOutsideClick: false
};

exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-modal/dist/index.js
// module id = 431
// module chunks = 168707334958949